import React from 'react';
import { Container, Section } from '../ui/Section';
import { ButtonExternal } from '../ui/Button';
import { DoodleArrow } from '../brand/Doodles';
import { externalLinks } from '../../data/site';
const steps = [{
  title: 'Check the latest event details',
  copy: 'BCM normally meets Thursdays at 7:30 PM. Check the Events page or Instagram for that week’s confirmed location.'
}, {
  title: 'Head to the Student Union',
  copy: 'Most weeks, BCM meets on the third floor in Cape Florida Ballroom, Room 316.'
}, {
  title: 'Come as you are',
  copy: 'You can attend on your own or bring a friend. You do not need to be Baptist or already have everything figured out.'
}, {
  title: 'Let someone know you’re coming',
  copy: 'Complete the Get Connected form if you would like a BCM leader to follow up, answer a question, or help you find the room.'
}];
export function FirstThursday() {
  return <Section id="first-thursday" className="relative overflow-hidden bg-[#fffdf6] py-16 sm:py-20" labelledBy="first-thursday-heading" data-id="element-140" data-mp="209pdo3q0ikt">
      <Container data-id="element-141" data-mp="o7cn5etw0twu">
        <div className="max-w-2xl" data-id="element-142" data-mp="o7w4oufmlgac">
          <h2 id="first-thursday-heading" className="font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-[2.6rem]" data-id="element-143" data-mp="o8xhb3caiau6">
            Your first Thursday doesn’t have to feel awkward
          </h2>
          <p className="mt-4 font-sans text-[17px] leading-relaxed text-ink" data-id="element-144" data-mp="1262h4lleudgz">
            Here is what to know before you come.
          </p>
        </div>

        <ol className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-145" data-mp="173m72irh0eor">
          {steps.map((step, index) => <li key={step.title} className="relative flex gap-4 rounded-[22px] border-2 border-brand-navy bg-brand-tan p-6" data-id="element-146" data-mp="saipibdvq0y1" data-mpi={index}>
              <span aria-hidden="true" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-brand-navy bg-white font-display text-lg font-bold text-brand-navy" data-id="element-147" data-mp="3cxvpik44fshw">
                {index + 1}
              </span>
              <div data-id="element-148" data-mp="1jh97613p1wc5">
                <h3 className="font-display text-xl font-bold leading-snug text-brand-navy" data-id="element-149" data-mp="1jgpy79w0uia9">
                  {step.title}
                </h3>
                <p className="mt-2 font-sans text-[15px] leading-relaxed text-ink" data-id="element-150" data-mp="19qmx0meqxy0u">{step.copy}</p>
              </div>
            </li>)}
        </ol>

        <div className="relative mt-10 flex flex-col gap-3 sm:flex-row sm:items-center sm:flex-wrap" data-id="element-151" data-mp="14scyc1ttcfah">
          <ButtonExternal href={externalLinks.studentUnion} data-id="element-152" data-mp="10rjcrf3ufckr">Get Directions</ButtonExternal>
          <ButtonExternal href={externalLinks.getConnectedForm} variant="secondary" data-id="element-153" data-mp="vqlvd4qnqmkb">
            Get Connected
          </ButtonExternal>
          <a href={externalLinks.instagram} target="_blank" rel="noopener noreferrer" className="font-meta text-sm font-semibold text-brand-navy underline underline-offset-4 hover:no-underline sm:ml-2" data-id="element-154" data-mp="2q44nfz1x5cy8">
            Ask on Instagram
          </a>
          <DoodleArrow className="pointer-events-none absolute -top-10 right-4 hidden h-14 w-14 lg:block" color="var(--bcm-pink)" data-id="element-155" data-mp="2xndyrxtzjlpx" />
        </div>
      </Container>
    </Section>;
}